import type {CSSProperties} from 'react';
import React from 'react';

interface SegmentedBarProps {
  segments: {
    label: string;
    value: number;
    percentage: number;
    color: string;
  }[];
  barStyle?: CSSProperties;
}

export const SegmentedBar = ({
  segments,
  barStyle = {
    borderRadius: 'var(--spacing-x0-quarter)',
    height: 'var(--spacing-x1)'
  }
}: SegmentedBarProps) => {
  const isEmpty = segments.every((segment) => segment.value === 0);

  const segmentsToUse = isEmpty
    ? [
        {
          ...segments[0],
          value: 0,
          percentage: 100
        }
      ]
    : segments;

  return (
    <div
      className='gap-x0-quarter flex w-full items-stretch overflow-hidden bg-transparent'
      data-testid='segmented-bar'
      style={barStyle}
    >
      {segmentsToUse.map(
        (segment) =>
          !!segment.percentage && (
            <div
              key={segment.label}
              style={{width: `${segment.percentage}%`, backgroundColor: segment.color}}
            />
          )
      )}
    </div>
  );
};
